// import Blank from "./Blank";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import {
  messagesApi,
  useGetMessagesQuery,
} from "../../../features/messages/messagesApi";
import Error from "../../ui/Error";
import ChatHead from "./ChatHead";
import Messages from "./Messages";
import Options from "./Options";

export default function ChatBody() {
  const { id } = useParams();
  const {
    data: messages,
    isLoading,
    isError,
    error,
  } = useGetMessagesQuery(id) || {};
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const dispatch = useDispatch();

  const fetchMore = () => {
    setPage((prevPage) => prevPage + 1);
  };

  useEffect(() => {
    if (page > 1) {
      dispatch(
        messagesApi.endpoints.getMoreMessages.initiate({
          id,
          page,
        })
      );
    }
  }, [page, id, dispatch]);

  useEffect(() => {
    if (messages?.totalCount > 0) {
      const more =
        Math.ceil(
          messages.totalCount / Number(process.env.REACT_APP_MESSAGES_PER_PAGE)
        ) > page;

      setHasMore(more);
    }
  }, [messages?.totalCount, page]);
  // decide what to render
  let content = null;

  if (isLoading) {
    content = <div>Loading...</div>;
  } else if (!isLoading && isError) {
    content = (
      <div>
        <Error message={error?.data} />
      </div>
    );
  } else if (!isLoading && !isError && messages?.data?.length === 0) {
    content = <div>No messages found!</div>;
  } else if (!isLoading && !isError && messages?.data?.length > 0) {
    content = (
      <>
        <ChatHead message={messages.data[0]} />
        <Messages
          hasMore={hasMore}
          fetchMore={fetchMore}
          messages={messages.data}
        />
        <Options info={messages.data[0]} />
      </>
    );
  }

  return (
    <div className="w-full lg:col-span-2 lg:block">
      <div className="w-full grid conversation-row-grid">{content}</div>
    </div>
  );
}
